// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 863) return "static/chunks/863-c63fe0aab0346ed6.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"129":"e5bf89630758fcce","142":"27c056f93b41cdca","225":"b3163d42d82db6a4"}[chunkId] + ".js";
};